import React, { useState } from "react";
import styles from "./Card.module.css";

interface CardProps {
    title: string;
    secondary?: boolean;
    side?: 'left' | 'right';
    children: React.ReactNode;
}

const Card: React.FC<CardProps> = ({ title, secondary, side, children }) => {
    const [cardColor] = useState(secondary ? '#012a54' : '#012a54d0');
    const [isDesktop] = useState<boolean>(!(window.innerWidth < 600));

    return (
        <div className={styles.card} style={{
            backgroundColor: cardColor,
            borderBottomLeftRadius: side === 'left' && isDesktop ? '150px' : 'none',
            borderBottomRightRadius: side === 'right' && isDesktop ? '150px' : 'none'
        }}>
            <div className={styles.title}>
                {title}
            </div>
            <div className={styles.text}>
                {children}
            </div>
        </div>
    );
};

export default Card;
